<template>
  <div>
    <div class="question-overlay question-overlay--left">
      <img :src="`${assetPath}lockup-overlays/quiz_01-overlay--left@2x.png`" alt="">
    </div>
    <div class="question-overlay question-overlay--top">
      <img :src="`${assetPath}lockup-overlays/quiz_01-overlay--top@2x.png`" alt="">
    </div>
    <div class="accessible-text">
      <p>We Have...</p>
    </div>
    <transition name="fade">
      <div :class="{ 'transitioned-in': initialized }">
        <div class="svg-wrapper">
          <WeHaveEmployees class="we-have-employees" />
        </div>
        <div class="svg-wrapper">
          <WeHaveEmployeesMobile class="we-have-employees--mobile" />
        </div>
        <form class="buttons">
          <template v-for="(question, index) in questions">
            <div :key="index">
              <input type="radio" :id="question.id" name="number" :value="question.value" @click="formInteraction(question.value)" :checked="question.value === number">
              <label :for="question.id"><span v-html="question.label"></span></label>
            </div>
          </template>
        </form>
      </div>
    </transition>
    <div class="accessible-text">
      <p>...Employees</p>
    </div>
    <div class="question-overlay question-overlay--right">
      <img :src="`${assetPath}lockup-overlays/quiz_01-overlay--right@2x.png`" alt="">
    </div>
    <div class="question-overlay question-overlay--bottom">
      <img :src="`${assetPath}lockup-overlays/quiz_01-overlay--bottom@2x.png`" alt="">
    </div>
  </div>
</template>

<script>
import { next } from './../../mixins/next.js'
import { assetPath } from './../../mixins/assetPath.js'
import WeHaveEmployees from '@/assets/we-have-employees.svg'
import WeHaveEmployeesMobile from '@/assets/we-have-employees--mobile.svg'

export default {
  name: 'QNumber',
  components: {
    WeHaveEmployees,
    WeHaveEmployeesMobile,
  },
  props: {
    initialized: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      questions: [
        {
          id: '<50',
          value: '<50',
          label: '&lt; 50'
        },
        {
          id: '50-100',
          value: '50-100',
          label: '50&ndash;100'
        },
        {
          id: '100-200',
          value: '100-200',
          label: '100&ndash;200'
        },
        {
          id: '>200',
          value: '>200',
          label: '200+'
        }
      ],
      localNumber: '100-200',
    }
  },
	computed: {
		number: {
      get() {
        return this.$store.state.quiz.number
      },
      set (localNumber) {
				this.$store.dispatch('changeQuizValue', { question: 'number', value: localNumber, type: 'question' })
			}
		}
	},
  methods: {
    formInteraction(value) {
      this.localNumber = value
      this.next('number', this.localNumber)
    }
  },
  mixins: [next, assetPath]
}
</script>

<style lang="scss">

.we-have-employees {
  display: none;
  @include breakpoint(large) {
    display: block;
  }
}
.we-have-employees--mobile {
  display: block;
  @include breakpoint(large) {
    display: none;
  }
}

.question--question-one {
  // background-image: url($q1bgMobile);
  background-size: cover;
  width: 100%;
  .svg-wrapper {
    width: 87.46%;
  }
  .question-overlay--top {
    top: -2vw;
  }
  .question-overlay--bottom {
    bottom: -2vw;
  }
  .question-overlay--left {
    width: 42.96%;
  }
  .question-overlay--right {
    width: 51.5625%;
  }
  @include breakpoint(medium) {
    .question-overlay--top {
      top: 0;
    }
    .question-overlay--bottom {
      bottom: 0;
    }
  }
  @include breakpoint(large) {
    .svg-wrapper {
      width: 67.5%;
      svg {
        height: 32vw; // for IE
      }
    }
    // background-image: url($q1bgDesktop);
  }
  .buttons {
    left: 0;
    right: 0;
    width: 86%;
    bottom: 40.75%;
    margin: 0 auto;
    div {
      width: 50%;
      margin-right: -3px;
      margin-bottom: -3px;
    }
    @include breakpoint(large) {
      bottom: 43%; // proto
      width: 64.5%;
      padding-right: 1em;
      div {
        width: 25%;
        margin-right: -3px;
      }
    }
  }
}

</style>